import { ContactsState } from './contacts.types'

export const state: ContactsState = {
  contacts: []
}
